import {appThemeColors} from "./chakraTheme";

export const borderRadius = 2
export const cornersBorderRadius = 24

export const datePickerStyle={ width: '100%',borderRadius: `${borderRadius}px`,borderColor: appThemeColors.borderColor}
export const selectAutoCompleteStyle={ width: '100%', borderRadius: `${borderRadius}px`,borderColor: appThemeColors.borderColor}
export const safeArea ={padding:'env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)'}
export const datePickerFullWidthStyle={ borderRadius: `${borderRadius}px`,borderColor: appThemeColors.borderColor,width: '100%'}
